// IMPORT PACKAGE REFERENCES
import React, { Component, Fragment } from 'react';

import { CurrentAnalysisStatsTable } from './CurrentAnalysisStatsTable';
import { Error } from '../../shared/Error/Error';
import { LoadingIndicator } from '../../shared/LoadingIndicator/LoadingIndicator';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// IMPORT PROJECT REFERENCES
import { fetchCurrentAnalysisStats } from '../../state/actions/AnalysisActions';

// COMPONENT
class CurrentAnalysisStatsBrowser extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.fetchCurrentAnalysisStats();
    }

    render() {
        const { analysisStats, failed, fetched, fetching } = this.props;

        if (!fetched) {
            return <LoadingIndicator busy={fetching} />;
        }

        if (failed) {
            return <Error message="Failed to fetch analysis stats records" />;
        }

        if (analysisStats) {
            const noRecords = !analysisStats.length && <div>No records found</div>;

            return (
                <Fragment>
                    {noRecords ? (
                        noRecords
                    ) : (
                        <CurrentAnalysisStatsTable analysisStats={analysisStats} />
                    )}
                </Fragment>
            );
        }

        return null;
    }
}

CurrentAnalysisStatsBrowser.propTypes = {
    fetchCurrentAnalysisStats: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    analysisStats: PropTypes.array,
    failed: PropTypes.bool,
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { fetching, fetched, failed, analysisStats } = state.analyses;

    return { fetching, fetched, failed, analysisStats };
};

const mapDispatchToProps = dispatch => bindActionCreators({ fetchCurrentAnalysisStats }, dispatch);

const hoc = connect(mapStateToProps, mapDispatchToProps)(CurrentAnalysisStatsBrowser);

// EXPORT COMPONENT
export { hoc as CurrentAnalysisStatsBrowser };
